import { IMG } from "../../data";
import { Reveal, RevealImg } from "./Reveal";

const cell = "relative overflow-hidden rounded-2xl bg-[#f2ece4] group";
const img =
  "h-full w-full object-cover transition-transform duration-700 group-hover:scale-105";

export const Gallery = () => (
  <section id="galeri" className="relative py-24 sm:py-32 bg-[#faf7f2]">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <Reveal>
        <p className="uppercase text-xs tracking-[0.28em] text-[#8b5a2b] mb-4">
          Galeri
        </p>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-[#2c1e16] max-w-3xl leading-tight">
          Momen tenang dari ruang rawat kami.
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5 auto-rows-[200px] sm:auto-rows-[240px]">
        <RevealImg className={`${cell} col-span-2 row-span-2`}>
          <img src={IMG.galTraditional} alt="Traditional Massage Javanese Spa Jogja" className={img} />
        </RevealImg>
        <RevealImg className={`${cell} col-span-2`}>
          <img src={IMG.galScrub} alt="Massage & Body Scrub tradisional" className={img} />
        </RevealImg>
        <RevealImg className={`${cell} col-span-2`}>
          <img src={IMG.galReflex} alt="Reflexology / refleksi kaki" className={img} />
        </RevealImg>
        <RevealImg className={`${cell} col-span-2`}>
          <img src={IMG.galFacial} alt="Massage & Totok Wajah" className={img} />
        </RevealImg>
      </div>
    </div>
  </section>
);
